import * as React from "react"
import type { SVGProps } from "react"
const SvgEducation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.05 18.06a2 2 0 0 1-.77-.74A2 2 0 0 1 5 16.3v-4.8l-2.4-1.33a1 1 0 0 1-.4-.37 1 1 0 0 1-.12-.5q0-.28.12-.5a1 1 0 0 1 .4-.38l8.45-4.6a2 2 0 0 1 1.44-.19q.24.06.46.19l9.53 5.2a1 1 0 0 1 .38.36 1 1 0 0 1 .14.52v6.4q0 .43-.29.7a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-5.9l-2 1.1v4.8a2 2 0 0 1-.27 1.03 2 2 0 0 1-.78.74l-5 2.7a2 2 0 0 1-1.44.19 2 2 0 0 1-.46-.19zM12 12.99l6.85-3.7L12 5.59l-6.85 3.7zM12 19l5-2.7v-3.77l-4.03 2.22a2 2 0 0 1-1.47.19 2 2 0 0 1-.47-.19L7 12.54v3.77z" />
  </svg>
)
export default SvgEducation
